import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Box, Typography } from "@mui/material";

function IconRowWithArrow({ sx = [], ...props }) {
  const {
    title,
    icon,
    onClick = () => {},
    value,
    valueColor = "grey.4",
    iconColor = "primary.main",
    greenBox = false,
    variant = "subtitle1",
  } = props;
  const Icon = icon;
  return (
    <Box
      onClick={onClick}
      sx={[
        {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {icon && <Icon width={24} height={24} />}
        <Typography variant="body2" color="grey.2" ml={icon ? 2 : 0}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant={variant}
          color={valueColor}
          mr={1}
          sx={{
            ...(greenBox && {
              padding: "4px 10px",
              borderRadius: "16px",
              color: "common.white",
              backgroundColor: "primary.main",
            }),
          }}
        >
          {value}
        </Typography>
        <KeyboardArrowLeftIcon sx={{ color: iconColor, height: 20 }} />
      </Box>
    </Box>
  );
}

export default IconRowWithArrow;
